module.exports = __webpack_public_path__ + "img/腳色介面_01-選擇2.aaa3dc91.png";